import axios from 'axios';

const api = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json',
    },
});


api.interceptors.request.use(
    (config) => {
        if (config.url && (config.url.startsWith('/admin') || config.url.includes('/admin'))) {
            const adminToken = sessionStorage.getItem('adminToken');
            if (adminToken) {
                config.headers.Authorization = `Bearer ${adminToken}`;
                return config;
            }
        }
        const token = localStorage.getItem('jwtToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403 || error.response.status === 400)) {
            const adminToken = sessionStorage.getItem('adminToken');
            if (adminToken || (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/adminLogin')) {
                sessionStorage.removeItem('adminToken');
                sessionStorage.removeItem('adminEmail');
                alert("세션이 만료되었습니다. 다시 로그인해주세요.");
                window.location.href = '/adminLogin';
                return Promise.reject(error);
            }

            const token = localStorage.getItem('jwtToken');
            if (token) {
               localStorage.removeItem('jwtToken');
                localStorage.removeItem('email');
                localStorage.removeItem('nickName');
                localStorage.removeItem('authorStatus');

                // 무한 리다이렉트 방지: 이미 메인페이지가 아닐 때만 리다이렉트
                if (window.location.pathname !== '/') {
                    alert("세션이 만료되었거나 유효하지 않은 요청입니다. 다시 로그인해주세요.");
                    window.location.href = '/';
                }
            }
        }
        return Promise.reject(error);
    }
);

/**
 * 메인 페이지
 */

export async function getMainBookList() {
    const response = await api.post(`/home/first`, {});
    return response.data;
}

export async function getNewAuthor() {
    const response = await api.post(`/home/second`, {});
    return response.data;
}

/**
 * 작가 리스트 페이지
 */

export async function getAuthors(
    page: number,
    size: number,
    filters?: { array: string[]; genre: string[]; textType: string[] }
) {
    try {
        const params = new URLSearchParams();
        params.append("page", page.toString());
        params.append("size", size.toString());

        if (filters?.array && filters.array.length > 0) {
            const sortTypeMap: Record<string, string> = {
                "등록순": "latest",
                "인기순": "popular",
            };
            const sortType = sortTypeMap[filters.array[0]] || "latest";
            params.append("sortType", sortType);
        } else {
            params.append("sortType", "latest");
        }

        // genres (장르) 쿼리 파라미터로 (복수일 경우 여러번 append 가능)
        filters?.genre.forEach((genre) => params.append("genres", genre));

        // keywords (글 유형) 쿼리 파라미터로
        filters?.textType.forEach((keyword) => params.append("keywords", keyword));

        const response = await api.post(`/arth/list?${params.toString()}`);
        return response.data;
    } catch (error) {
        //console.error("Error fetching authors:", error);
        throw error;
    }
}


export async function getAuthorInfo(params: { authorEmail?: string; authorName?: string; authorId?: number }) {
    try {
        const response = await api.post(`/arth/info`, params);
        return response.data; // 여기서 필요한 데이터를 반환
    } catch (error) {
        // console.error("Error fetching authors:", error);
        throw error; // 에러가 발생하면 호출한 쪽에서 처리를 할 수 있게 함
    }
}

export async function getAdminAuthorInfo(email: string) {
    try {
        const response = await api.post(`/admin/arth/info`, { authorEmail: email });
        return response.data; // 여기서 필요한 데이터를 반환
    } catch (error) {
        // console.error("Error fetching authors:", error);
        throw error; // 에러가 발생하면 호출한 쪽에서 처리를 할 수 있게 함
    }
}

export async function updateAuthorStatus(email: string, status: string, rejectReason?: string) {
    try {
        const response = await api.post(`/admin/arth/update`, { 
            authorEmail: email, 
            authorStatus: status,
            rejectReason: rejectReason,
            rejectionReason: rejectReason,
            reason: rejectReason
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function getHoldAuthorList(
    page: number,
    size: number
) {
    try {
        const response = await api.post(`/admin/arth/holdList?page=${page}&size=${size}`, {});
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function getAuthorNoteList(page: number, authorEmail: string, categoryName?: string) {
    try {
        const response = await api.post(`/arth/noteList?page=${page}`, { authorEmail, categoryName });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function registAuthorNote(formData: FormData) {
    try {
        const response = await api.post(`/arth/noteReg`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function deleteAuthorNote(noteId: string) {
    try {
        const response = await api.post(`/arth/noteDel`, { noteId });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function getPostCardDetail(id: number) {
    try {
        const response = await api.post(`/post/info?postCardId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function getAuthorNoteDetail(noteId: string) {
    try {
        const response = await api.post(`/arth/noteInfo`, { noteId });
        return response.data;
    } catch (error) {
        throw error;
    }
}


export async function getBookList(email: string) {
    try {

        const authorEmail = email

        const response = await api.post(
            '/book/list',
            { authorEmail: email }
        );
        return response.data; // 여기서 필요한 데이터를 반환
    } catch (error) {
        //console.error("Error fetching authors:", error);
        throw error; // 에러가 발생하면 호출한 쪽에서 처리를 할 수 있게 함
    }
}


export async function getBook(id: string) {
    try {

        const response = await api.post(
            '/book/info',
            { bookId: id },
        );
        return response.data; // 여기서 필요한 데이터를 반환
    } catch (error) {
        //console.error("Error fetching authors:", error);
        throw error; // 에러가 발생하면 호출한 쪽에서 처리를 할 수 있게 함
    }
}


export async function bookUpdate(id: string, bookData: any, file?: File) {
    try {
        const formData = new FormData();
        formData.append('bookId', id);
        for (const key in bookData) {
            if (bookData.hasOwnProperty(key)) {
                formData.append(key, bookData[key]);
            }
        }

        if (file) {
            formData.append('backgroundPhoto', file);
        }

        const response = await axios.post('/book/update', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });

        return response.data;
    } catch (error) {
        // console.error("Error updating book:", error);
        throw error;
    }
}


export async function bookDelete(id: string) {
    try {

        const response = await api.post(
            '/book/remove',
            { bookId: id },
        );
        return response.data;
    } catch (error) {
        // console.error("Error fetching authors:", error);
        throw error;
    }
}






/**
 * 작품 스토리
 */
export async function getNewBooks() {
    try {
        const response = await api.post(`/story/first`, null);
        return response.data; // 여기서 필요한 데이터를 반환
    } catch (error) {
        //console.error("Error fetching authors:", error);
        throw error; // 에러가 발생하면 호출한 쪽에서 처리를 할 수 있게 함
    }
}


export async function getBookStroys() {
    try {
        const response = await api.post(`/story/second`, null);
        return response.data; // 여기서 필요한 데이터를 반환
    } catch (error) {
        //  console.error("Error fetching authors:", error);
        throw error; // 에러가 발생하면 호출한 쪽에서 처리를 할 수 있게 함
    }
}


export async function getSeed() {
    try {
        const response = await api.post(`/story/getThirdSeed`, null);
        return response.data; // 여기서 필요한 데이터를 반환
    } catch (error) {
        //console.error("Error fetching authors:", error);
        throw error; // 에러가 발생하면 호출한 쪽에서 처리를 할 수 있게 함
    }
}


export async function getCategoryBooks(catalog: string, page: number, seed: string) {
    try {

        // const seed = await getSeed();
        const response = await api.post(`/story/third?page=${page}`, {
            seed: seed,
            catalog: catalog,
        });

        return response.data;
    } catch (error) {
        //console.error("Error fetching category books:", error);
        throw error;
    }
}

/**
 * 엽서 등록 페이지
 *
 */
export async function addPostCard(formData: FormData) {
    try {
        const response = await api.post(`/post/reg`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        // console.error("Error uploading postcard:", error);
        throw error;
    }
}

export async function getPostCard(page: number, size: number, sortType?: number) {
    try {


        const params = new URLSearchParams();
        params.append("page", page.toString());

        params.append("size", size.toString());
        params.append("sortType", sortType === 0 ? "latest" : "popular");



        const response = await api.post(`/post/list?${params.toString()}`, {}, {});
        //console.log("response:::" , response)
        return response.data;
    } catch (error) {
        //console.error("Error uploading postcard:", error);
        throw error;
    }
}

export async function getAdminPostCardList(page: number, size: number) {
    try {
        const params = new URLSearchParams();
        params.append("page", page.toString());
        params.append("size", size.toString());

        const response = await api.post(`/admin/post/list?${params.toString()}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}


export async function deletePostCard(id: number) {

    try {
        const response = await api.post(`/post/remove?postCardId=${id}`, {}, {

        });
        return response.data;
    } catch (error) {
        //  console.error("Error uploading postcard:", error);
        throw error;
    }
}

export async function updatePostCardText(id: number, text: string) {

    try {
        const response = await api.post(`/post/update`, { postCardId: id, postCardDescription: text }, {

        });
        return response.data;
    } catch (error) {
        //console.error("Error uploading postcard:", error);
        throw error;
    }
}


/**
 *
 * 프로필 수정
 *
 */
export async function getProfileList(authorEmail: string) {

    try {

        const response = await api.post(`/arth/info`, { authorEmail: authorEmail });

        return response.data;
    } catch (error) {
        // console.error("Error uploading postcard:", error);
        throw error;
    }
}

export async function updateProfile(formData: FormData) {
    try {

        const response = await api.post(`/arth/update`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        //console.error("Error uploading postcard:", error);
        throw error;
    }
}

/**
 *
 * 좋아요 팔로우
 *
 */
export async function getLike(email: string) {
    try {
        //좋아요한 작가 이메일 눌러야 됨
        const response = await api.post(`/user/arthLike`, { authorEmail: email });
        return response.data; // 여기서 필요한 데이터를 반환
    } catch (error) {
        //console.error("Error fetching authors:", error);
        throw error; // 에러가 발생하면 호출한 쪽에서 처리를 할 수 있게 함
    }
}

export async function setBookLike(id: string) {
    try {

        const response = await api.post(`/user/bookLike`, { bookId: id });

        return response.data;
    } catch (error) {
        //console.error("Error fetching authors:", error);
        throw error;
    }
}

export async function setPostCardLike(id: string) {
    try {

        const response = await api.post(`/user/postCardLike`, { postCardId: id });

        return response.data;
    } catch (error) {
        // console.error("Error fetching authors:", error);
        throw error;
    }
}


/**
 *
 * 마이 페이지 (작품/작가/엽서 좋아요)
 *
 */

export async function getProfile() {
    try {

        const response = await api.post(`/user/info`, null);
        return response.data;
    } catch (error) {
        //console.error("Error fetching authors:", error);
        throw error;
    }
}


export async function getLikeBookList(page: number, size: number) {
    try {

        const response = await api.post(`/user/likeBookList?page=${page - 1}&size=${size}`, null);

        return response.data;
    } catch (error) {
        //  console.error("Error fetching authors:", error);
        throw error;
    }
}

export async function getLikePostCardList(page: number, size: number) {
    try {

        const response = await api.post(`/user/likePostCardList?page=${page - 1}&size=${size}`, null);

        return response.data;
    } catch (error) {
        // console.error("Error fetching authors:", error);
        throw error;
    }
}

export async function getLikeAuthorCardList(page: number, size: number) {
    try {

        const response = await api.post(`/user/likeAuthorList?page=${page - 1}&size=${size}`, null);
        return response.data;
    } catch (error) {
        // console.error("Error fetching authors:", error);
        throw error;
    }
}

export async function getMypageBookList(page: number, size: number) {
    try {

        const response = await api.post(`/user/registeredBookList?page=${page - 1}&size=${size}`, null);

        return response.data;
    } catch (error) {
        //console.error("Error fetching authors:", error);
        throw error;
    }
}


export async function getMypagePostCardList(page: number, size: number) {
    try {

        const response = await api.post(`/user/registeredPostCardList?page=${page - 1}&size=${size}`, null);
        return response.data;
    } catch (error) {
        //console.error("Error fetching authors:", error);
        throw error;
    }
}

/**
 * 댓글 (Comment) API
 */
export async function getCommentList(noteId: string, page: number = 0, size: number = 10) {
    try {
        const response = await api.post(`/comment/list`, {
            targetId: noteId,
            targetType: 'AUTHOR_NOTE',
            page,
            size
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching comments:", error);
        throw error;
    }
}

export async function registerComment(noteId: string, content: string, parentId?: string) {
    try {
        const response = await api.post(`/comment/reg`, {
            targetId: noteId,
            targetType: 'AUTHOR_NOTE',
            content,
            parentId: parentId || null // 대댓글일 경우 부모 댓글 ID
        });
        return response.data;
    } catch (error) {
        console.error("Error registering comment:", error);
        throw error;
    }
}

export async function deleteComment(commentId: string) {
    try {
        const response = await api.post(`/comment/delete`, { commentId });
        return response.data;
    } catch (error) {
        console.error("Error deleting comment:", error);
        throw error;
    }
}

export async function getReplyList(parentId: string, page: number = 0, size: number = 10) {
    try {
        const response = await api.post(`/comment/replies`, {
            parentId,
            page,
            size
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function reportComment(commentId: string) {
    try {
        const response = await api.post(`/comment/report`, { commentId });
        return response.data;
    } catch (error) {
        console.error("Error reporting comment:", error);
        throw error;
    }
}

export async function likeComment(commentId: string) {
    try {
        const response = await api.post(`/comment/like`, { commentId });
        return response.data;
    } catch (error) {
        console.error("Error liking comment:", error);
        throw error;
    }
}

export async function downloadPostCard(postCardId: number | string) {
    const response = await api.post(`/post/download?postCardId=${postCardId}`, {}, {
        responseType: 'blob'
    });
    return response;
}

export async function getReportedComments(page: number = 1, size: number = 10) {
    try {
        const adminToken = sessionStorage.getItem('adminToken');
        const response = await api.post(`/admin/comment/reported?page=${page}&size=${size}`, {}, {
            headers: {
                Authorization: `Bearer ${adminToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching reported comments:", error);
        throw error;
    }
}

export async function postCommentAction(commentId: number | string, action: 'BLOCK' | 'DISMISS') {
    try {
        const adminToken = sessionStorage.getItem('adminToken');
        const response = await api.post(`/admin/comment/action`, { commentId, action }, {
            headers: {
                Authorization: `Bearer ${adminToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error performing action on comment:", error);
        throw error;
    }
}

/**
 * 알림 API
 */

// 헤더 최근 알림 10건 조회
export async function getNotificationList() {
    try {
        const response = await api.post('/notifications/list');
        return response.data;
    } catch (error) {
        console.error("Error fetching notification list:", error);
        throw error;
    }
}

// 알림 스크롤 조회 (페이지는 1부터 시작)
export async function getNotificationScroll(page: number, unreadOnly: boolean = false) {
    try {
        const response = await api.post('/notifications/scroll', { page, unreadOnly });
        return response.data;
    } catch (error) {
        console.error("Error fetching notification scroll:", error);
        throw error;
    }
}

// 개별 알림 읽음 처리
export async function readNotification(notiId: string | number) {
    try {
        const response = await api.post('/notifications/read', { notiId: String(notiId) });
        return response.data;
    } catch (error) {
        console.error("Error reading notification:", error);
        throw error;
    }
}

// 전체 알림 읽음 처리
export async function readAllNotifications() {
    try {
        const response = await api.post('/notifications/read-all');
        return response.data;
    } catch (error) {
        console.error("Error reading all notifications:", error);
        throw error;
    }
}

// 안 읽은 알림 개수 조회
export async function getUnreadCount() {
    try {
        const response = await api.post('/notifications/unread-count');
        return response.data;
    } catch (error) {
        console.error("Error fetching unread count:", error);
        throw error;
    }
}

// 알림 이메일 설정 조회
export async function getNotificationSettings() {
    try {
        const response = await api.get('/notifications/settings');
        return response.data;
    } catch (error) {
        console.error("Error fetching notification settings:", error);
        throw error;
    }
}

// 알림 이메일 설정 변경
export async function updateNotificationSettings(emailEnabled: boolean) {
    try {
        const response = await api.put('/notifications/settings', { emailEnabled });
        return response.data;
    } catch (error) {
        console.error("Error updating notification settings:", error);
        throw error;
    }
}

